<template>
  <el-container>
    <el-header style="height: 20px;">
      <span class="company">亲爱的：{{currentUser.person.name}}</span>
      <span class="company" style="margin-left: 10px">当前公司：{{companyOrgs[this.index].name}}</span>
      <el-button class="but3" size="small" @click="changeCompany">点此切换公司</el-button>
      <el-button class="but3" size="small" style="margin-left: -10px" @click="logout">退出登录</el-button>
    </el-header>
    <el-divider class="div_top"></el-divider>
    <el-main class="main">
      <span class="text"><img class="icon_payHistory" src="@/assets/images/icon_payHistory.png" alt=""/>付款历史查询</span>
      <el-main class="con">
        <el-form style="margin-left: 10px" :disabled="loading">
          <el-form-item>
            <span style="color: red">*</span>
            <span style="margin-left: 5px">开始日期：</span>
            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="startDate" :picker-options="startPickerOptions"></el-date-picker>
            <span style="color: red;margin-left: 20px">*</span>
            <span style="margin-left: 5px">结束日期：</span>
            <el-date-picker size="small" value-format="yyyy-MM-dd" v-model="endDate" :picker-options="endPickerOptions"></el-date-picker>
          </el-form-item>
          <el-form-item v-if="currentUser.userType === 1">
            <span style="color: red">*</span>
            <span style="margin-left: 5px">客户姓名：</span>
            <el-select size="small"
                       v-model="selectedCustomerId"
                       placeholder="请选择"
                       filterable
                       :filter-method="dataFilter"
                       ref="select"
                       :clearable="showClose"
                       @blur.native.capture="onblur"
                       @hook:mounted="cancelReadOnly"
                       @visible-change="cancelReadOnly">
              <el-option
                v-for="item in customersOption"
                :key="item.customerID"
                :label="item.customerName+' | '+item.customerNumber"
                :value="item.customerID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <span style="color: red">*</span>
            <span style="margin-left: 5px">操作人员：</span>
            <el-select v-model="selectedOperatorType" filterable placeholder="请选择" @change="operatorChange" size="small">
              <el-option v-for="item in operatorOption" :key="item.type" :label="item.content" :value="item.type"></el-option>
            </el-select>
            <span style="color: red;margin-left: 20px">*</span>
            <span style="margin-left: 5px">收款单状态：</span>
            <el-select v-model="selectedPayStatus" filterable placeholder="请选择" @change="payStatusChange" size="small">
              <el-option v-for="item in payStatusOption" :key="item.type" :label="item.content" :value="item.type"></el-option>
            </el-select>
            <span style="color: red;margin-left: 20px">*</span>
            <span style="margin-left: 5px">网银来源：</span>
            <el-select v-model="selectedPayType" filterable placeholder="请选择" @change="payTypeChange" size="small">
              <el-option v-for="item in payTypeOption" :key="item.type" :label="item.content" :value="item.type"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="submit">
            <el-button type="primary" @click="payHistoryQuery" :loading="loading">提交查询信息</el-button>
            <download-excel
              class = "export-excel-wrapper"
              :data = "tableData"
              :fields = "json_fields"
              :name = "'付款历史_'+this.getDay(0)"
              style="display: inline;margin-left: 20px">
              <el-button type="primary">导出表</el-button>
            </download-excel>
          </el-form-item>
        </el-form>
      </el-main>
      <el-main class="list">
        <el-table :data="tableData" :stripe="true" :border="true" :fit="true" size="mini">
          <el-table-column label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button type="primary" size="small" :disabled="disabled" @click="repairPay(scope.$index , scope.row)" v-if="scope.row.easBillNumber === null || scope.row.easBillNumber === ''">补银联单据</el-button>
              <el-button style="background: #f5f7fa" v-else size="small" disabled>补银联单据</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="orderId" label="订单号"></el-table-column>
          <el-table-column prop="createTime" label="订单时间"></el-table-column>
          <el-table-column prop="companyName" label="付款公司"></el-table-column>
          <el-table-column prop="customerName" label="付款客户"></el-table-column>
          <el-table-column prop="accountMoney" label="付款金额"></el-table-column>
          <el-table-column label="付款状态" min-width="50px">
            <template slot-scope="scope">
              <!--农行授权支付--><!--农行直联支付--><!--农行手机支付-->
              <span v-if="(scope.row.payType === 'ABC_AUTH_PAY' && scope.row.returnCode === '0000') || ((scope.row.payType === 'ABC_PC_PAY' || scope.row.payType === 'ABC_PHONE_PAY') && scope.row.payReturnCode === '0000')">成功</span>
              <span v-else style="color:red">失败</span>
            </template>
          </el-table-column>
          <el-table-column label="是否生成收款单" min-width="60px">
            <template slot-scope="scope">
              <span v-if="scope.row.accountStatus === true">是</span>
              <span v-else style="color:red">否</span>
            </template>
          </el-table-column>
          <el-table-column prop="easBillNumber" label="收款单号"></el-table-column>
          <el-table-column label="操作人身份">
            <template slot-scope="scope">
              <span v-if="scope.row.payOperatorType === '0'">客户</span>
              <span v-if="scope.row.payOperatorType === '1'">业务员</span>
              <span v-if="scope.row.payOperatorType === '2'">财务人员</span>
            </template>
          </el-table-column>
          <el-table-column prop="paySourceType" label="支付类型"></el-table-column>
        </el-table>
      </el-main>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10,20,50,100]"
                     :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" style="margin-top: 10px"></el-pagination>
    </el-main>
  </el-container>
</template>

<script>

import {mapGetters} from "vuex";
import {queryCustomerByFinance} from "../../../api/system/pay_history";
import {queryPayRecordList, repairPay} from "../../../api/system/pay";

export default {
  data() {
    return {
      startPickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      endPickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      startDate:this.getDay(-6),
      endDate:this.getDay(0),
      customersOption: [],
      selectedCustomerId:'',
      operatorOption:[
        {type:-1 , content:'全部'},
        {type:2 , content:'财务人员'},
        {type:1 , content:'业务员'},
        {type:0 , content:'客户'}
      ],
      selectedOperatorType:-1,
      payStatusOption:[
        {type:-1 , content:'全部'},
        {type:1 , content:'已生成收款单'},
        {type:0 , content:'未生成收款单'}
      ],
      selectedPayStatus:-1,
      payTypeOption:[
        {type:-1 , content:'全部'},
        {type:'ABC_PC_PAY' , content:'农行直联支付'},
        {type:'ABC_PHONE_PAY' , content:'农行手机支付'},
        {type:'ABC_AUTH_PAY' , content:'农行授权支付'}
        // {type:'GATEWAY_PC_PAY' , content:'银联网关支付'},
        // {type:'GATEWAY_PHONE_PAY' , content:'银联手机支付'},
        // {type:'EPOS_PHONE_PAY' , content:'易POS支付'}
      ],
      selectedPayType:-1,
      currentPage:1,
      pageSize:10,
      total:0,
      timeLineHeight: "",
      tableData:[],
      showClose:false,
      loading:false,
      disabled:false,
      json_fields:{
        "订单号": {
          field:"orderId",
          callback: value => {
            return "&nbsp;"+value
          }
        },
        "付款公司":"companyName",
        "付款客户":"customerName",
        "收款单金额":{
          field:"accountMoney",
            callback: value => {
            return "&nbsp;"+value
          }
        },
        "单据状态":{
          field:"accountStatus",
          callback: value => {
            if(value === true){
              return "成功"
            }else{
              return "失败"
            }
          }
        },
        "收款单号":"easBillNumber",
        "操作人身份":{
          field:"payOperatorType",
          callback: value => {
            if(value === 2){
              return "财务人员"
            }else if(value === 1){
              return "业务员"
            }else{
              return "客户"
            }
          }
        },
        "订单时间":"createTime",
        "支付类型":"paySourceType"
      },
    }
  },
  watch:{

  },
  computed: {
    ...mapGetters(["currentUser"]),
    ...mapGetters(["companyOrgs"]),
    ...mapGetters(["index"])
  },
  mounted() {
    this.timeLineHeight = document.documentElement.clientHeight -50;
    window.onresize = () => {
      this.timeLineHeight = document.documentElement.clientHeight;
    };
    let _this = this;
    queryCustomerByFinance({
      companyID : _this.companyOrgs[_this.index].id
    }).then(res => {
      _this.customersOption = res.data.userInfo;
      _this.customerList = res.data.userInfo;
    }).catch(e => {
      console.log(e);
    });
    // this.refreshTable();
  },
  methods: {
    customerChange(customerId) {
    },
    operatorChange(operatorType){
    },
    payStatusChange(statusType){
    },
    payTypeChange(payTypeKey){
    },
    changeCompany() {
      this.$confirm('确定要切换公司么？', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.push({path: '/system/company/finance'})
      }).catch(() => {

      });
    },
    logout() {
      let that = this;
      that.$modal.confirm('是否确认退出小禾订货平台？').then(function() {
        that.$store.dispatch("LogOut").then(() => {
          that.$store.dispatch("ClearMenu");
          sessionStorage.clear()
          that.$router.push({ path: that.redirect || "/login" }).catch(()=>{});
        }).catch(() => {});
      })
    },
    onblur() {
      setTimeout(() => {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) { //判断iPhone|iPad|iPod|iOS
          this.$refs.select.blur();
        }
        this.showClose = false
        let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
    },
    cancelReadOnly(onOff) {
      if (onOff) { // 打开下拉框 显示可清空按钮
        this.showClose = true
      }
      this.$nextTick(() => {
        if (!onOff) {
          const {select} = this.$refs;
          const input = select.$el.querySelector('.el-input__inner');
          input.removeAttribute('readonly');
          // this.$refs.select.blur();  根据tip自行判断是否添加
        }
      });
    },
    //下拉框开启搜索功能
    dataFilter(val) {
      this.value = val;
      if (val) { //val存在
        this.customersOption = this.customerList.filter((item) => {
          if (!!~item.customerName.indexOf(val) || !!~item.customerName.toUpperCase().indexOf(val.toUpperCase()) || !!~item.customerNumber.indexOf(val) || !!~item.customerNumber.toUpperCase().indexOf(val.toUpperCase()) || !!~item.mnemoniccode.indexOf(val) || !!~item.mnemoniccode.toUpperCase().indexOf(val.toUpperCase())) {
            return true
          }
        })
      } else { //val为空时，还原数组
        this.customersOption = this.customerList;
      }
    },
    getDay(day) {
      //Date()返回当日的日期和时间。
      let days = new Date();
      //getTime()返回 1970 年 1 月 1 日至今的毫秒数。
      let getTimes = days.getTime() + 1000 * 60 * 60 * 24 * day;
      //setTime()以毫秒设置 Date 对象。
      days.setTime(getTimes);
      let year = days.getFullYear();
      let month = days.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      let today = days.getDate();
      if (today < 10) {
        today = "0" + today;
      }
      return year + "-" + month + "-" + today;
    },

    refreshTable(){
      let _this = this;
      let groupQuery = {current:this.currentPage , size:this.pageSize};
      //构建查询条件
      if(this.startDate !== null && this.startDate !== ''){
        groupQuery.startTime = this.startDate + ' 00:00:00';
      }
      if(this.endDate !== null && this.endDate !== ''){
        groupQuery.endTime = this.endDate + ' 23:59:59';
      }
      //todo 替换全部
      if(this.selectedCustomerId !== ''){
        groupQuery.customerId = this.selectedCustomerId;
      }
      if(this.selectedOperatorType !== -1){
        groupQuery.payOperatorType = this.selectedOperatorType;
      }
      if(this.selectedPayStatus !== -1){
        groupQuery.accountStatus = this.selectedPayStatus;
      }
      if(this.selectedPayType !== -1){
        groupQuery.payType = this.selectedPayType;
      }
      //todo 调用网银交易查询接口
      groupQuery.companyId = _this.companyOrgs[_this.index].id
      //console.log(groupQuery);
      queryPayRecordList(JSON.stringify(groupQuery)).then(res => {
        _this.tableData = res.data.records;
        _this.total = res.data.total;
        this.loading = false;
      }).catch(e =>{
        console.log(e);
        this.loading = false;
      })
    },
    handleSizeChange(val){
      this.pageSize = val;
      this.refreshTable();
    },
    handleCurrentChange(val){
      this.currentPage = val;
      this.refreshTable();
    },
    exportTable(){

    },
    payHistoryQuery(){
      this.loading = true;
      this.currentPage = 1;
      this.pageSize = 10;
      this.total = 0;
      this.refreshTable();
    },
    repairPay(index, row){
      let payTypeId = ''
      if(row.payType === 'ABC_PHONE_PAY' || row.payType === 'ABC_PC_PAY' || row.payType === 'ABC_AUTH_PAY'){
        // if(row.payType === 'GATEWAY_PC_PAY' || row.payType === 'GATEWAY_PHONE_PAY' || row.payType === 'ABC_PHONE_PAY' || row.payType === 'ABC_PC_PAY' || row.payType === 'ABC_AUTH_PAY'){
        repairPay({orderId:row.orderId,payTypeId:payTypeId}).then(res =>{
          // console.log(res)
          if(res.code === 200){
            this.$modal.msgSuccess("结算通知单生成成功，单据号："+res.data.easBillNumber);
            row.easBillNumber = res.data.easBillNumber
            row.accountStatus = true
          }
        }).catch(e=>{
          console.log(e)
        })
      } else{
        this.$message.error("该支付类型不支持该操作！");
      }
    }
  }
}
</script>

<style scoped>
  .main{
    overflow: auto;
    height: 86vh;
  }
  .company{
    font-size: 14px;
    color:rgb(143, 143, 143)
  }
  .but3{
    font-size: 14px;
    color: rgb(240, 57, 74);
    border: none;
    background: white;
    font-weight: 600;
  }
  .div_top{
    margin: 12px 0;
  }
  .icon_payHistory{
    width: 18px;
    height: 20px;
    display: flex;
    margin-top: 3px;
    margin-right: 10px;
  }
  .text{
    display: flex;
    color: rgb(239, 51, 69);
    font-size: 20px;
    font-weight: 700;
    line-height: 25px;
    letter-spacing: 1px;
    text-align: left;
    /*margin: 0 8px;*/
  }
  .con{
    margin-top: 10px;
    border: 1px solid rgb(196, 196, 196);
  }
  .list{
    margin-top: 30px;
    border: 1px solid rgb(196, 196, 196);
  }
  .submit{
    text-align: center;
  }
</style>
